class CheckoutOffer extends HTMLElement {
  #dialog;
  #addedOfferItem = false;
  #formatter;

  connectedCallback() {
    this.#dialog = this.querySelector('dialog');
    if (!this.#dialog) return;

    this.#formatter = new Intl.NumberFormat(this.dataset.locale || 'en-AU', {
      style: 'currency',
      currency: this.dataset.currency || 'AUD',
    });

    this.querySelector('[data-offer-close]')?.addEventListener('click', this.#close);
    this.querySelector('[data-carousel-previous]')?.addEventListener('click', () => this.#scrollCarousel(-1));
    this.querySelector('[data-carousel-next]')?.addEventListener('click', () => this.#scrollCarousel(1));

    this.querySelectorAll('[data-offer-add]').forEach((button) => {
      button.addEventListener('click', this.#addOfferProduct);
    });

    this.querySelectorAll('select[data-offer-variant]').forEach((select) => {
      select.addEventListener('change', this.#updateCardPrice);
    });
  }

  open() {
    if (
      !this.#dialog ||
      this.#dialog.open ||
      this.dataset.offerUsed === 'true' ||
      !this.querySelector('[data-offer-card]')
    ) {
      return false;
    }

    this.#dialog.showModal();
    return true;
  }

  #addOfferProduct = async (event) => {
    if (this.#addedOfferItem) return;

    const button = event.currentTarget;
    const card = button.closest('[data-offer-card]');
    const variantControl = card?.querySelector('[data-offer-variant]');
    const status = card?.querySelector('[data-offer-status]');
    if (!variantControl?.value) return;

    button.disabled = true;
    button.textContent = 'Adding…';
    if (status) status.textContent = '';

    try {
      const cartResponse = await fetch(window.Theme?.routes?.cart_url || '/cart.js', {
        headers: { Accept: 'application/json' },
      });
      const currentCart = await cartResponse.json();
      const cartAlreadyHasOffer = currentCart.items?.some(
        (item) => item.properties?._checkout_offer === 'true'
      );

      if (cartAlreadyHasOffer) {
        this.#addedOfferItem = true;
        this.dataset.offerUsed = 'true';
        this.querySelectorAll('[data-offer-add]').forEach((addButton) => {
          addButton.disabled = true;
        });
        if (status) status.textContent = 'Your cart already contains its one checkout bonus item.';
        this.querySelector('[data-offer-success]')?.removeAttribute('hidden');
        this.querySelector('[data-continue-checkout]')?.removeAttribute('hidden');
        this.querySelector('[data-skip-offer]')?.setAttribute('hidden', '');
        return;
      }

      const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(variantControl.value),
              quantity: 1,
              properties: {
                _checkout_offer: 'true',
                _checkout_offer_discount: this.dataset.discountCents,
              },
            },
          ],
        }),
      });

      const data = await response.json();
      if (!response.ok || data.status) {
        throw new Error(data.description || data.message || 'This item could not be added.');
      }

      this.#addedOfferItem = true;
      this.dataset.offerUsed = 'true';
      button.textContent = 'Added';
      this.querySelectorAll('[data-offer-add]').forEach((addButton) => {
        addButton.disabled = true;
      });
      this.querySelector('[data-offer-success]')?.removeAttribute('hidden');
      this.querySelector('[data-continue-checkout]')?.removeAttribute('hidden');
      this.querySelector('[data-skip-offer]')?.setAttribute('hidden', '');
    } catch (error) {
      button.disabled = false;
      button.textContent = 'Try again';
      if (status) status.textContent = error.message;
    }
  };

  #updateCardPrice = (event) => {
    const select = event.currentTarget;
    const card = select.closest('[data-offer-card]');
    const selectedOption = select.selectedOptions[0];
    const originalCents = Number(selectedOption?.dataset.price || 0);
    const discountedCents = Math.max(0, originalCents - Number(this.dataset.discountCents || 2000));

    const originalPrice = card?.querySelector('[data-offer-original-price]');
    const offerPrice = card?.querySelector('[data-offer-price]');
    if (originalPrice) originalPrice.textContent = this.#formatter.format(originalCents / 100);
    if (offerPrice) offerPrice.textContent = this.#formatter.format(discountedCents / 100);
  };

  #scrollCarousel(direction) {
    const carousel = this.querySelector('[data-offer-carousel]');
    carousel?.scrollBy({
      left: direction * Math.min(carousel.clientWidth * 0.8, 720),
      behavior: 'smooth',
    });
  }

  #close = () => {
    this.#dialog.close();
  };
}

if (!customElements.get('checkout-offer')) {
  customElements.define('checkout-offer', CheckoutOffer);
}

document.addEventListener('click', (event) => {
  const checkoutLink = event.target.closest('[data-checkout-offer-trigger]');
  if (!checkoutLink) return;

  const offer = document.querySelector('checkout-offer');
  if (offer?.dataset.offerUsed === 'true' && offer.dataset.discountUrl) {
    event.preventDefault();
    window.location.assign(offer.dataset.discountUrl);
    return;
  }

  if (offer?.open()) {
    event.preventDefault();
  }
});
